module.exports = __webpack_public_path__ + "assets/TParallel.15ca3f42a061cf8c73ae88622c7e7a2e.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TParallel.gmt
// module id = 1014
// module chunks = 0